import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
interface OfferSectionProps {
  onAddToCart?: () => void;
}
export function OfferSection({
  onAddToCart
}: OfferSectionProps) {
  return <section id="offer" className="bg-gradient-to-br from-amber-light/40 to-amber/20 py-24 px-6" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <FadeIn data-id="element-137">
          <div className="bg-white rounded-3xl p-8 md:p-16 shadow-warm-lg text-center border border-amber/20" data-id="element-138">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading" data-id="element-139">
              Get "The Grandparent's Smartphone Survival Guide"
            </h2>

            <div className="my-10" data-id="element-140">
              <p className="text-charcoal/60 font-medium uppercase tracking-widest text-sm mb-1" data-id="element-141">
                One-Time Payment
              </p>
              <p className="text-sage font-semibold text-sm mb-2" data-id="element-142">
                ⚡ Instant Access — Digital Download
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-143">
                <span className="text-2xl md:text-3xl text-warmBrown/60 line-through font-medium" data-id="element-144">
                  $19.99
                </span>
                <span className="text-6xl md:text-7xl font-bold text-charcoal" data-id="element-145">
                  $6.39
                </span>
              </div>
              <p className="mt-2 text-sm font-semibold text-sage uppercase tracking-wide" data-id="element-146">
                🎉 Discount Price — Save 68%!
              </p>
            </div>

            <p className="text-xl md:text-2xl text-warmBrown font-heading leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-147">
              One less frustrating tech support call is worth far more than
              that, and you can give your parents the confidence to use their
              phone on their own.
            </p>

            <CTAButton href="https://www.shopdilore.com/cart/53789543104822:1" onClick={onAddToCart} data-id="element-148" />
          </div>
        </FadeIn>
      </div>
    </section>;
}